import { Link } from "react-router-dom";
import "./fab.css";

export interface FABProps {
  /** Navigation target. Provide either `to` or `onClick`. */
  to?: string;
  /** Click handler (button mode) — e.g. opening the <AddReceiptMenu>. */
  onClick?: () => void;
  ariaLabel: string;
  /** For `onClick` mode: reflects an open popup for assistive tech. */
  ariaHasPopup?: boolean;
  ariaExpanded?: boolean;
  /** Displayed glyph. Default: "+". */
  children?: React.ReactNode;
}

/**
 * Floating action button, sticky bottom-right. Used on the receipts list.
 * Per design-system §6, primary brand fill + shadow-fab. Renders as a <Link>
 * when `to` is given, or a <button> when `onClick` is given (US-20: the FAB
 * opens the <AddReceiptMenu> chooser rather than routing straight to camera).
 */
export function FAB({
  to,
  onClick,
  ariaLabel,
  ariaHasPopup,
  ariaExpanded,
  children = "+",
}: FABProps) {
  if (onClick) {
    return (
      <button
        type="button"
        className="wp-fab"
        aria-label={ariaLabel}
        aria-haspopup={ariaHasPopup ? "dialog" : undefined}
        aria-expanded={ariaHasPopup ? !!ariaExpanded : undefined}
        onClick={onClick}
        data-testid="fab"
      >
        <span aria-hidden="true">{children}</span>
      </button>
    );
  }
  return (
    <Link to={to ?? "#"} className="wp-fab" aria-label={ariaLabel} data-testid="fab">
      <span aria-hidden="true">{children}</span>
    </Link>
  );
}
